import { api } from './api';

export interface Vehicle { id: string; name: string; registrationNumber: string | null; capacity: number; driverName: string | null; driverMobile: string | null; isActive: boolean; }
export interface Stop { id: string; name: string; sequence: number; pickupTime: string | null; latitude: number | null; longitude: number | null; }
export interface Route { id: string; name: string; vehicleId: string | null; isActive: boolean; stops: Stop[]; }

export interface StopInput { name: string; sequence: number; pickupTime?: string | null; latitude?: number | null; longitude?: number | null; }

export const transportApi = {
  listVehicles: () => api.get<Vehicle[]>('/api/transport/vehicles'),
  createVehicle: (b: { name: string; registrationNumber?: string | null; capacity: number; driverName?: string | null; driverMobile?: string | null }) =>
    api.post<Vehicle>('/api/transport/vehicles', b),

  listRoutes: () => api.get<Route[]>('/api/transport/routes'),
  createRoute: (b: { name: string; vehicleId?: string | null }) => api.post<Route>('/api/transport/routes', b),
  setStops: (routeId: string, stops: StopInput[], vehicleId?: string | null) =>
    api.put<Route>(`/api/transport/routes/${routeId}/stops`, { stops, vehicleId: vehicleId ?? null }),

  assign: (studentId: string, routeId: string, stopId: string) =>
    api.post<{ assigned: boolean }>(`/api/transport/students/${studentId}/assign`, { routeId, stopId }),

  tripAlert: (routeId: string, direction: 'Departed' | 'Arriving', note?: string) =>
    api.post<{ notified: number }>(`/api/transport/routes/${routeId}/trip-alert`, { direction, note: note ?? null }),


};
